import template from './hotel-room-super-room.html';
import amenitiesTooltipOfSuperRoom from './hotel-super-room-amenities-tooltip.html';

const DIRECTIVE_NAME = HotelRoomSuperRoom.DIRECTIVE_NAME = 'ktHotelRoomSuperRoom';
export default function HotelRoomSuperRoom() {
    return {
        restrict: 'A',
        template,
        bindToController: true,
        controller: HotelRoomSuperRoomController,
        controllerAs: '$ctrl',
        scope: {
            model: `=${DIRECTIVE_NAME}`,
        },
        link: ($scope, $elem, $attrs, $ctrl) => $ctrl.$onInit(),
    };
}

export function HotelRoomSuperRoomController() {
    const vm = this;

    Object.assign(vm, {
        $onInit,
    });

    function $onInit() {
        Object.assign(vm, {
            amenitiesTooltipOfSuperRoom,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/hotels/hotel-room/hotel-room-super-room/hotel-room-super-room-component.js